import React, {useRef, useLayoutEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {ThemeContext} from '../../';

const MessageField = (props) => {
  const {placeholder, sendButtonText, className, sendMessage} = props;
  const classes = classNames({
    'chat__input-text': true,
    [className]: Boolean(className),
  });
  const messageTextEl = useRef(null);

  useLayoutEffect(() => {
    if (messageTextEl.current) {
      messageTextEl.current.focus();
    }
  }, []);

  const onSendMessage = (evt) => {
    const value = messageTextEl.current.value;
    if (!value) {
      return false;
    }
    if (!evt.key) {
      messageTextEl.current.value = '';
      sendMessage(value);
    } else if (evt.key === 'Enter') {
      evt.preventDefault();
      messageTextEl.current.value = '';
      sendMessage(value);
      return false;
    }
    return false;
  };

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const sendStyles = {
          color: theme.primaryColor,
        };
        return (
          <div className={classes}>
            <textarea className="chat__control" placeholder={placeholder} ref={messageTextEl} onKeyDown={onSendMessage}/>
            <button className="chat__send" type="submit" onClick={onSendMessage} style={sendStyles}>{sendButtonText}</button>
          </div>
        );
      }}
    </ThemeContext.Consumer>
  );
};

MessageField.propTypes = {
  placeholder: PropTypes.string,
  sendButtonText: PropTypes.string,
  className: PropTypes.string,
  sendMessage: PropTypes.func,
};

MessageField.defaultProps = {
  placeholder: 'Type message here',
  sendButtonText: 'Send',
  className: '',
  sendMessage: () => {},
};

export default MessageField;
